module.exports = __webpack_public_path__ + "static/finning-logo-d58e1a3feed9d7ff54d8da22c0279199.jpg";